var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPensionInsuranceCompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_2e3780c838e906299df5ae0702a9c8aae9ef858abf6c8197581d827f12f0baf8",
    x1: 62.159,
    y1: 88.95,
    x2: 140.727,
    y2: 88.95,
    gradientTransform: "rotate(6.394 101.444 88.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M107.288 141.516c-18.233 2.043-35.737-4.067-46.889-16.353-1.899-2.092-2.04-5.381-.09-7.425a5.309 5.309 0 017.803.116c8.724 9.732 23.281 14.753 37.993 13.105 14.601-1.636 27.6-9.641 34.009-20.919 1.379-2.427 4.326-3.68 6.888-2.571a5.313 5.313 0 012.548 7.465c-8.114 14.589-23.913 24.527-42.261 26.583zM84.317 97.055l-8.288 26.298M119.877 93.07l13.904 23.812M81.972 84.943l-8.359-20.988-2.855-7.163-11.987-30.084a5.311 5.311 0 00-6.896-2.969 5.317 5.317 0 00-2.967 6.907l22.128 55.522M86.491 62.512l2.427 21.652M104.259 60.521l2.427 21.652M124.452 80.18l-1.47-13.12"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "MI_4L_gradient",
    x: 63.407,
    y: 82.799,
    width: 76.072,
    height: 12.302,
    rx: 4.291,
    ry: 4.291,
    transform: "rotate(-6.394 101.439 88.95)",
    stroke: "url(#SVGID_0_2e3780c838e906299df5ae0702a9c8aae9ef858abf6c8197581d827f12f0baf8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M98.802 53.65l-28.05 3.14 2.86 7.16 30.65-3.43.18-.02c0 .01.01 0 .01 0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_gradient",
    cx: 122.027,
    cy: 40.281,
    r: 26.798,
    stroke: "url(#SVGID_0_2e3780c838e906299df5ae0702a9c8aae9ef858abf6c8197581d827f12f0baf8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M127.533 35.537s-1.027-5.702-5.632-5.65c-4.606.052-5.778 5.78-5.778 5.78l12.066 9.17M116.777 44.966s1.027 5.702 5.632 5.65c4.606-.052 5.778-5.78 5.778-5.78",
    stroke: "url(#SVGID_0_2e3780c838e906299df5ae0702a9c8aae9ef858abf6c8197581d827f12f0baf8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_a0d2af5da2ca188cfa296af4bb04291a5f21c3e723e409a1944338ed7c19341d)",
    d: "M121.983 25.019l.055 4.866"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_2e3780c838e906299df5ae0702a9c8aae9ef858abf6c8197581d827f12f0baf8)",
    d: "M122.272 50.617l.055 4.867"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPensionInsuranceCompanies);
export default __webpack_public_path__ + "static/media/pensionInsuranceCompanies.91ac6909301edc9cbdfee2acde122012.svg";
export { ForwardRef as ReactComponent };